import React, { useContext, useEffect, useState } from "react";
import { Card, Label, ModalBody, Badge, Modal, ModalHeader } from "reactstrap";
import {
  Button,
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Col,
  Row,
  OverlineTitle,
  Sidebar,
  UserAvatar,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  PreviewAltCard,
  TooltipComponent,
} from "../../../components/Component";
import PropTypes from 'prop-types';
import { useHistory, useLocation } from "react-router";
import InputMask from 'react-input-mask';
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { GetTenantIdUp, currentTime, findUpper, formDataUsername, indianNumRegex, monthNames, timeStamp, todaysDate, urlTenantID, usaNumRegex, usaNumRegex2 } from "../../../utils/Utils";
import { UserContext } from "../user-manage/UserContext";
import { notes } from "../user-manage/UserData";
import Api from "../../../Api";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";
import { cloneDeep } from "lodash";
import { Tabs, Tab, Box, Link } from '@mui/material';
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import moment from "moment-timezone";

const EditTenant = ({ match }) => {
  const [tenantDetailState, setTenantDetail] = useState(
    {
      TenantId: urlTenantID(),
      name: "",
      organizationName: "",
      contactName: "",
      firstName: "",
      middleName: "",
      lastName: "",
      emailId: "",
      streetAddress: "",
      city: "",
      timeZone: "",
      state: "",
      zip: "",
      country: "",
      updatedBy: formDataUsername,
      isActive: true,
      phoneNo: "",
      // tenantHost: [
      //   {
      //     ThID: 4,
      //     // ThID: 4,
      //     // hostUrl: "https://localhost:44365",
      //     hostUrl: "https://localhost:44365",
      //     hostIp: "192.168.1.41",
      //     updatedBy: "TestDv",
      //     isActive: true
      //   }
      // ],
      // tenantLicense: [
      //   {
      //     TlID: 7,
      //     licCode: "L-000001",
      //     tenantId: 1,
      //     serviceStartDate: "2022-08-26T00:00:00.000Z",
      //     updatedBy: "TestDv",
      //     isActive: true
      //   }
      // ],
      tenantPhone: [
        {
          tphId: 2,
          phoneNo: "(+1) 999 999 9999",
          updatedBy: formDataUsername,
          isActive: true,
          tenantId: urlTenantID(),
        }
      ],
      // tenantSecret: [
      //   {
      //     tsid: 7,
      //     applicationName: "RingTestRemind",
      //     apiKey: "AC2125f886cdeade6af4013e5b66d92cd0",
      //     apiSecret: "8db40d652e8a3fda7de78190fd0328bb",
      //     updatedBy: "TestDv",
      //     isActive: true
      //   }
      // ]
    }
  );
  const [contryListState, setCountryList] = useState([]);
  const [stateListState, setStateList] = useState([]);
  const [timezones, setTimezones] = useState([]);

  const callGetTenantDetail = async () => {
    try {
      const response = await Api.GetTenantByTenantID({ TenantId: match.params.id });
      const countryList = await Api.GetAdminCountryList();
      setCountryList(countryList)
      const stateList = await Api.GetAdminState(countryList?.find(ele => ele?.countryName === response?.country)?.countryId || 239);
      setStateList(stateList);
      let record = cloneDeep(tenantDetailState);
      record.name = response?.name;
      record.organizationName = response?.organizationName;
      record.contactName = response?.contactName;
      record.firstName = response?.firstName;
      record.middleName = response?.middleName;
      record.lastName = response?.lastName;
      record.streetAddress = response?.streetAddress;
      record.city = response?.city;
      record.country = response?.country;
      record.state = `${response?.state}`;
      record.zip = +response?.zip;
      record.emailId = response?.emailId;
      record.phoneNo = (response?.tenantPhone?.[0]?.phoneNo)?.replace("+1", '');
      record.timeZone = response?.timeZone || "";
      record.tenantPhone[0].tphId = response?.tenantPhone[0]?.tphId;
      setTenantDetail(record)
    } catch (error) {
    }
  }
  const callGetAdminCountryList = async () => {
    const countryList = await Api.GetAdminCountryList();
    setCountryList(countryList);
  }
  const callGetAdminState = async (CountryId) => {
    const stateList = await Api.GetAdminState(CountryId);
    setStateList(stateList);
  }
  useEffect(async () => {
    await callGetTenantDetail();
    const allTimezones = moment.tz.names();
    const timezonesData = allTimezones.map((timezone) => {
      const offset = moment.tz(timezone).format("Z"); // Get timezone offset in ±HH:mm format
      const gmtOffset = `(GMT${offset})`;
      const timezoneName = timezone.replace(/_/g, ' '); // Replace underscores with spaces
      return `${gmtOffset} ${timezoneName}`;
    });
    let url = +(location?.pathname)?.split("/")?.[4];
    if(typeof url === "number"){
        sessionStorage?.setItem("tempTenantId", url);
    }

    setTimezones(timezonesData);
  }, []);
  // console.log("callGetTenantDetail-=-=",tenantDetailState);

  const { contextData } = useContext(UserContext);
  const [data] = contextData;
  const [sideBar, setSidebar] = useState(false);
  const [user, setUser] = useState();
  const [noteData, setNoteData] = useState(notes);
  const [addNoteModal, setAddNoteModal] = useState(false);
  const [addNoteText, setAddNoteText] = useState("");

  const history = useHistory();

  const [regexs, setRegexs] = useState({
    // name: /^[\w\s]+$/,
    name: /^[\w\s.]+$/,
    email: /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/,
    // phone: /^\(\+1\) \d{3} \d{3} \d{4}$/,
    phone: /^\(\d{3}\) \d{3}-\d{4}$/,
    zip: /^\d{5}$/,
    urlHost: /\bhttps?:\/\/[^\s/$.?#].[^\s]*\b/,
    hostIp: /\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/,
    streetAddress: /.+/,
  });

  const [error, setError] = useState({
    name: "",
    organizationName: "",   
    contactName: "",
    firstName: "",
    middleName: "",
    lastName: "",
    streetAddress: "",
    city: "",
    country: "",
    state: "",
    zip: "",
    emailId: "",
    timeZone: "",
    PhoneType: "",
    phoneNo: "",
    somethingWentWrong: "",
  });

  const [hostErrors, setHostErrors] = useState({
    hostUrl: "",
    hostIp: "",
    somethingWentWrong: "",
  });
  const location = useLocation("");

  const [thId, setThId] = useState("");

  const [modal, setModal] = useState({
    add: false,
  });
  const { errorss, register, handleSubmit } = useForm();

  const [values, setValues] = useState(0);
  const handleChanges = (event, newValue) => {
    setValues(newValue);
  };

  const [hostList, setHostList] = useState([]);

  const [hostValue, setHostValue] = useState({
    hostUrl: "",
    hostIp: "",
  })

  // grabs the id of the url and loads the corresponding data
  useEffect(() => {
    let url = +(location?.pathname)?.split("/")?.[4];
    if(typeof url === "number"){
        sessionStorage?.setItem("tempTenantId", url);
    }
    const id = match.params.id;
    if (id !== undefined || null || "") {
      let spUser = data.find((item) => item.id === Number(id));
      setUser(spUser);
      getHostList(urlTenantID());
    } else {
      setUser(data[0]);
    }

  }, [match.params.id, data]);

  // function to toggle sidebar
  const toggle = () => {
    setSidebar(!sideBar);
  };

  // delete a note
  const deleteNote = (id) => {
    let defaultNote = noteData;
    defaultNote = defaultNote.filter((item) => item.id !== id);
    setNoteData(defaultNote);
  };

  const submitNote = () => {
    let submitData = {
      id: Math.random(),
      text: addNoteText,
      date: `${monthNames[todaysDate.getMonth()]} ${todaysDate.getDate()}, ${todaysDate.getFullYear()}`,
      time: `${currentTime()}`,
      company: "Softnio",
    };
    setNoteData([...noteData, submitData]);
    setAddNoteModal(false);
    setAddNoteText("");
  };

  const handleChange = ({ target }) => {
    const { name, value } = target;
    if (name == "country") {
      callGetAdminState(value)
    } else {
      if (name === "zip") {
        if (value?.length <= 5) {
          setTenantDetail({ ...tenantDetailState, [name]: value })
        }
      } else {
        setTenantDetail({ ...tenantDetailState, [name]: value });
      }
    }
  };

  const onSave = async (e) => {
    e.preventDefault();
    let errors = cloneDeep(error);
    Object.keys(tenantDetailState).forEach((key) => {
      const value = tenantDetailState[key];
      switch (key) {
        case "name":
        case "organizationName":
        case "contactName":
        case "firstName":
        case "middleName":
        case "lastName":
        case "city":
          if (!regexs.name.test(value)) {
            errors[key] = `Enter Valid ${key}`;
          } else {
            errors[key] = "";
          }
          break;
        case "streetAddress":
          if (!regexs.streetAddress.test(value)) {
            errors[key] = `Enter Valid ${key}`;
          } else {
            errors[key] = "";
          }
          break;
        case "zip":
          if (!regexs.zip.test(value)) {
            errors[key] = "Enter Valid Zip code";
          } else {
            errors[key] = "";
          }
          break;
        case "emailId":
          if (!regexs.email.test(value)) {
            errors[key] = "Enter Valid Email";
          } else {
            errors[key] = "";
          }
          break;
        case "phoneNo":
          if (!usaNumRegex.test(value)) {
            errors[key] = "Enter Valid Number";
          } else {
            errors[key] = "";
          }
          break;
        default:
          break;
      }
      errors.somethingWentWrong = "";
    });

    if (Object.values(errors).every(value => value === "")) {
      let response;
      try {
        let datas = cloneDeep(tenantDetailState);
        datas.phoneNo = "+1" + datas?.phoneNo;
        datas.tenantPhone[0].phoneNo = datas?.phoneNo;
        response = await Api.UpdateTenant(datas);
        if(response?.data?.statusCode === 200){
          Swal?.fire({
            icon: response?.data?.message?.includes("success") ? "success" : "error",
            title: response?.data?.message?.includes("success") ? "Tenant Updated Successfully" : "Something Went Wrong"
          });
          history?.push("/Tenant/Accounts/manage-tenant")
        }else{
          errors.somethingWentWrong = "Something Went Wrong";
        }
      
      } catch (error) {
        errors.somethingWentWrong = "Something Went Wrong";
      }
    }
    setError(errors)
    // console.log("responseUpdateTenant-=-=",responseUpdateTenant);
  }

  // const InsertSingleTenantHost = async ({ hostUrl, hostIp }) => {
  //   try {
  //     let datas = {
  //       "tenantId": urlTenantID(),
  //       "hostUrl": hostUrl,
  //       "hostIp": hostIp,
  //       "createdBy": timeStamp(),
  //       "createdOn": timeStamp(),
  //       "updateBy": formDataUsername(),
  //       "updateOn": timeStamp(),
  //       "isActive": true,
  //     }
  //     let response = await Api?.InsertSingleTenantHost(datas);
  //     if(response?.data?.statusCode === 200){
  //       Swal?.fire({
  //         icon: "success",
  //         title: "Host Added Successfully"
  //       });
  //       getHostList(urlTenantID());
  //       setModal({ ...modal, add: false });
  //       setHostValue({ ...hostValue, hostUrl: "", hostIp: "" })
  //     }
  //    else{
  //     Swal?.fire({
  //       icon: "error",
  //       title: "Something Went Wrong"
  //     })
  //    }

  //   } catch (error) {
  //     Swal?.fire({
  //       icon: "error",
  //       title: "Something Went Wrong"
  //     })
  //   }
  // }

  const handleAddHost = async(eve) => {
    eve?.preventDefault();
    const errorss = {
      hostUrl: !regexs?.urlHost?.test(hostValue?.hostUrl) ? "Please Enter Valid Host URL." : "",
      hostIp: !regexs?.hostIp?.test(hostValue?.hostIp) ? "Please Enter Valid Host IP." : "",
      somethingWentWrong: "",
    };
    if (!errorss.hostUrl && !errorss.hostIp) {
      // InsertSingleTenantHost({
      //   hostUrl: hostValue?.hostUrl,
      //   hostIp: hostValue?.hostIp
      // })
      try {
        let datas = {
          "tenantId": urlTenantID(),
          "hostUrl": hostValue?.hostUrl,
          "hostIp": hostValue?.hostIp,
          "createdBy": timeStamp(),
          "createdOn": timeStamp(),
          "updateBy": formDataUsername(),
          "updateOn": timeStamp(),
          "isActive": true,
        }
        let response = await Api?.InsertSingleTenantHost(datas);
        if(response?.data?.statusCode === 200){
          Swal?.fire({
            icon: "success",
            title: "Host Added Successfully"
          });
          getHostList(urlTenantID());
          setModal({ ...modal, add: false });
          setHostValue({ ...hostValue, hostUrl: "", hostIp: "" })
        }
       else{
        errorss.somethingWentWrong = "Something Went Wrong";
       }
  
      } catch (error) {
        errorss.somethingWentWrong = "Something Went Wrong";
      }
    }
    setHostErrors(errorss);
  }

  const onFormCancel = (eve) => {
    eve?.preventDefault();
    setModal({ ...modal, add: false });
  }

  const onFormSubmit = (eve) => {
    eve?.preventDefault();
    setModal({ ...modal, add: false });
  }

  const getHostList = async (id) => {
    try {
      let response = await Api.GetTenantHostById(id);
      setHostList(response);
    } catch (error) {
      // Swal?.fire({
      //   icon: "error",
      //   title: "Something Went Wrong"
      // })
    }
  }

  const deleteTenantHosts = async ({ tenantId, thId, hostIp }) => {
    try {
      let datas = {
        "thID": thId,
        "updateBy": hostIp,
        "tenantId": tenantId
      }
      let response = await Api?.deleteTenantHost(datas);
      Swal?.fire({
        icon: "success",
        title: "Host Deleted Successfully"
      });
      getHostList(urlTenantID());
    } catch (error) {
      Swal?.fire({
        icon: "error",
        title: "Something Went Wrong"
      });
    }
  }
  const handleHostChange = (eve) => {
    const { name, value } = eve?.target;
    setHostValue({ ...hostValue, [name]: value })
  }

  // useEffect(() => {

  // }, []);

  return (
    <React.Fragment>
      <Head title="User Details - Regular"></Head>
      {/* {user && ( */}
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                Edit Tenant Detail
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <Button
                color="light"
                outline
                className="bg-white d-none d-sm-inline-flex"
                onClick={() => history.goBack()}
              >
                <Icon name="arrow-left"></Icon>
                <span>Back</span>
              </Button>
              <a
                href="#back"
                onClick={(ev) => {
                  ev.preventDefault();
                  history.goBack();
                }}
                className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"
              >
                <Icon name="arrow-left"></Icon>
              </a>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <Card className="card-bordered tabs_sec">
            <Tabs value={values} onChange={handleChanges} className="nav nav-tabs nav-tabs-mb-icon nav-tabs-card ps-0" aria-label="basic tabs example">
              <Tab label="Detail" className="tabs_name" />
              <Tab label="Host" className="tabs_name" />
            </Tabs>
          </Card>

        </Block>

        <Block>
          {values === 0 && <Card className="card-bordered">
            <div className="card-aside-wrap" id="user-detail-block">
              <div className="card-content">

                <div className="card-inner">
                  <Block>
                    <form>
                      <Row className="mb-3">
                        <Col md="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="first-name">
                              Name
                            </Label>
                            <div className="form-control-wrap">
                              <input onChange={handleChange} name="name" className="form-control bg-blue-dim" type="text" id="first-name" value={tenantDetailState.name} />
                              {error?.name !== "" && <span className="invalid">{error?.name}</span>}
                            </div>
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="middle-name">
                              Org Name
                            </Label>
                            <div className="form-control-wrap">
                              <input onChange={handleChange} name="organizationName" className="form-control bg-blue-dim" type="text" id="middle-name" value={tenantDetailState.organizationName} />
                              {error?.organizationName !== "" && <span className="invalid">{error?.organizationName}</span>}
                            </div>
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="last-name">
                              Contact Name
                            </Label>
                            <div className="form-control-wrap">
                              <input onChange={handleChange} name="contactName" className="form-control bg-blue-dim" type="text" id="last-name" value={tenantDetailState.contactName} />
                              {error?.contactName !== "" && <span className="invalid">{error?.contactName}</span>}
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col md="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="first-name">
                              First Name
                            </Label>
                            <div className="form-control-wrap">
                              <input onChange={handleChange} name="firstName" className="form-control bg-blue-dim" type="text" id="first-name" value={tenantDetailState?.firstName} />
                              {error?.firstName !== "" && <span className="invalid">{error?.firstName}</span>}
                            </div>
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="first-name">
                              Middle Name
                            </Label>
                            <div className="form-control-wrap">
                              <input onChange={handleChange} name="middleName" className="form-control bg-blue-dim" type="text" id="first-name" value={tenantDetailState?.middleName} />
                              {error?.middleName !== "" && <span className="invalid">{error?.middleName}</span>}
                            </div>
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="middle-name">
                              Last Name
                            </Label>
                            <div className="form-control-wrap">
                              <input onChange={handleChange} name="lastName" className="form-control bg-blue-dim" type="text" id="middle-name" value={tenantDetailState.lastName} />
                              {error?.lastName !== "" && <span className="invalid">{error?.lastName}</span>}
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col md="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="first-name">
                              Street Address
                            </Label>
                            <div className="form-control-wrap">
                              <input onChange={handleChange} name="streetAddress" className="form-control bg-blue-dim" type="text" id="first-name" value={tenantDetailState.streetAddress} />
                              {error?.streetAddress !== "" && <span className="invalid">{error?.streetAddress}</span>}
                            </div>
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="middle-name">
                              City
                            </Label>
                            <div className="form-control-wrap">
                              <input onChange={handleChange} name="city" className="form-control bg-blue-dim" type="text" id="middle-name" value={tenantDetailState.city} />
                              {error?.city !== "" && <span className="invalid">{error?.city}</span>}
                            </div>
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="last-name">
                              Country
                            </Label>
                            <div className="form-control-wrap">
                              <div className="form-control-select">
                                <select
                                  onChange={handleChange} name="country"
                                  className="form-control form-select bg-blue-dim"
                                  id="fv-topics"
                                  placeholder="Select a option"
                                  value={tenantDetailState.country}
                                  disabled
                                >
                                  {contryListState.length > 0
                                    ? contryListState.map((item, ind) => (
                                      <option label={item.countryName} value={item.countryId} key={ind}></option>
                                    )) : null}
                                </select>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col md="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="first-name">
                              State
                            </Label>
                            <div className="form-control-wrap">
                              <div className="form-control-select">
                                <select
                                  onChange={handleChange} name="state"
                                  className="form-control form-select bg-blue-dim"
                                  id="fv-topics"
                                  placeholder="Select a option"
                                  value={tenantDetailState.state}
                                >

                                  {stateListState?.length > 0
                                    ? stateListState.map((item) => (
                                      <option label={item.stateName} value={item.stateId}></option>
                                    ))
                                    : null}
                                </select>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="middle-name">
                              Zip
                            </Label>
                            <div className="form-control-wrap">
                              <input onChange={handleChange} name="zip" value={tenantDetailState.zip} className="form-control bg-blue-dim" type="number" max="99999" id="middle-name" maxLength={5} />
                              {error?.zip !== "" && <span className="invalid">{error?.zip}</span>}
                            </div>
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="first-name">
                              Email ID
                            </Label>
                            <div className="form-control-wrap">
                              <input onChange={handleChange} name="emailId" className="form-control bg-blue-dim" type="text" id="first-name" value={tenantDetailState.emailId} />
                              {error?.emailId !== "" && <span className="invalid">{error?.emailId}</span>}
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col md="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="middle-name">
                              Time Zone
                            </Label>
                            <div className="form-control-wrap">
                              <div className="form-control-select">
                                <select
                                  className="form-control form-select bg-blue-dim"
                                  id="fv-topics"
                                  name="timeZone"
                                  placeholder="Select a option"
                                  value={tenantDetailState?.timeZone}
                                  onChange={handleChange}
                                >
                                  {timezones.map((timezone, index) => (
                                    <option key={index} value={timezone}>{timezone}</option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="fv-topics">
                              PhoneType
                            </Label>
                            <div className="form-control-wrap">
                              <div className="form-control-select">
                                <select
                                  className="form-control form-select bg-blue-dim"
                                  id="fv-topics"
                                  name="topics"
                                  placeholder="Select a option"
                                >
                                  <option label="Home" value="Home"></option>
                                  <option value="Office">Office</option>
                                  <option value="Cell">Cell</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="fv-topics">
                              Phone Number
                            </Label>
                            <div className="form-control-wrap">
                              <InputMask
                                onChange={handleChange}
                                value={tenantDetailState?.phoneNo}
                                name="phoneNo"
                                mask='(999) 999-9999'
                                className="form-control bg-blue-dim"
                                placeholder="(999) 999-9999"
                                autoComplete="phone"
                                type="text"
                              >
                              </InputMask>
                              {/* <input onChange={handleChange} name="phoneNo" value={tenantDetailState.phoneNo} className="form-control bg-blue-dim" type="text" id="first-name" /> */}
                              {error?.phoneNo !== "" && <span className="invalid">{error?.phoneNo}</span>}
                              {error?.somethingWentWrong !== "" && <span className="invalid">{error?.somethingWentWrong}</span>}
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <div className="justify-end">
                        <Button onClick={onSave} color="primary" className="me-3">Save</Button>
                      </div>
                    </form>
                  </Block>
                </div>
              </div>
            </div>
          </Card>}
          {values === 1 && <Card className="card-bordered">

            <Block>
              <Button color="primary" className={"d-block ms-auto me-2 mt-2"} onClick={() => setModal({ add: true })}>
                <Icon name="plus" />
                <Link>
                  <span style={{ color: "white" }}>Add</span>
                </Link>
              </Button>
              <div className="nk-tb-list is-separate is-medium mb-3">
                <DataTableHead>
                  <DataTableRow>
                    <span className="sub-text text-dark fw-bold">Host Url</span>
                  </DataTableRow>
                  <DataTableRow size="md">
                    <span className="sub-text text-dark fw-bold">Host Ip</span>
                  </DataTableRow>
                  <DataTableRow size="lg">
                    <span className="sub-text text-dark fw-bold">Action</span>
                  </DataTableRow>
                </DataTableHead>
                {/*Head*/}
                {hostList?.map((ele, ind) => {
                  return <DataTableItem className={"nk_tb_col_pad"} key={ind}>
                    <DataTableRow size="mb">
                      <span className="nk_tb_col_pad"> {ele?.hostUrl} </span>
                    </DataTableRow>
                    <DataTableRow size="md">
                      <span className="nk_tb_col_pad">{ele?.hostIp}</span>
                    </DataTableRow>
                    <DataTableRow className="nk-tb-col-tools">
                      <ul className="nk-tb-actions justify-content-start">
                        <li className="ps-0" onClick={eve => deleteTenantHosts(
                          {
                            tenantId: ele?.tenantId,
                            thId: ele?.thId,
                            hostIp: ele?.hostIp,
                          }
                        )}>
                          <TooltipComponent
                            tag="a"
                            containerClassName="btn btn-trigger btn-icon btn-danger text-white py-1 rounded-circle trash_btn"
                            id={"Configuration"}
                            icon="trash"
                            direction="top"
                            text="Delete Host"
                          />
                        </li>
                      </ul>
                    </DataTableRow>
                  </DataTableItem>
                })}

              </div>
              <PreviewAltCard>
                {/* {hostList ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={data.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No data found</span>
              </div>
            )} */}
              </PreviewAltCard>
            </Block>
          </Card>}
        </Block>
      </Content>
      <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
        <ModalHeader
          close={
            <button className="close" href="#close"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}>
              <Icon name="cross" />
            </button>
          }
        >
          Add Host
        </ModalHeader>
        <ModalBody>
          <form onSubmit={handleSubmit(handleAddHost)} autoComplete="off">
            <Row className="mb-3">
              <Col md="12">
                <div className="form-group">
                  <label className="form-label"> Host Url </label>
                  <input
                    name="hostUrl"
                    value={hostValue.hostUrl}
                    onChange={eve => handleHostChange(eve)}
                    className="form-control bg-blue-dim"
                    type="text"
                    placeholder="Enter Host url"
                    autoComplete="firstname"
                  />
                  {hostErrors?.hostUrl !== "" && <span className="invalid">{hostErrors?.hostUrl}</span>}
                </div>
              </Col>
              <Col md="12" className="pt-4">
                <div className="form-group">
                  <label className="form-label"> Host IP </label>
                  <input
                    name="hostIp"
                    value={hostValue.hostIp}
                    onChange={eve => handleHostChange(eve)}
                    className="form-control bg-blue-dim"
                    type="text"
                    placeholder="Enter Host Ip"
                    autoComplete="middlename"
                  />
                  {hostErrors?.hostIp !== "" && <span className="invalid">{hostErrors?.hostIp}</span>}
                  {hostErrors?.somethingWentWrong !== "" && <span className="invalid">{hostErrors?.somethingWentWrong}</span>}
                </div>
              </Col>
            </Row>
            <div className="justify-end">
              <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                <li>
                  <Button onClick={eve => handleAddHost(eve)} color="primary" size="md" type="submit">
                    Save
                  </Button>
                </li>
                <li>
                  <a
                    href="#cancel"
                    onClick={(ev) => {
                      ev.preventDefault();
                      onFormCancel();
                    }}
                    className="link link-light"
                  >
                    Cancel
                  </a>
                </li>
              </ul>
            </div>
          </form>
        </ModalBody>
      </Modal>


    </React.Fragment>
  );
};
export default EditTenant;
